<div class="mat-elevation-z2 control-strip">

   <div style="display: inline-block; width: 33%;padding-top:5px;">
     		 <button *ngIf=" _caseRecord?.caseStatus === 'Open' && visibleAddNewCaseRequest"
			        mat-button
			        matTooltipPosition="right"
			        style="scale: 95%"
			        class="command-button command-button-override"
			        matTooltip="Add a new service request"
			        (click)="doAddNew()"
			        mat-button>
			    <mat-icon class="command-icon-style">add_circle_outline</mat-icon>
			    Add New
			</button>
			
			
   </div>
   <div style="display: inline-block; width: 33%;text-align:center">

       <!--
       <input text style="height:25px;"
               id="txtFilter" #txtFilter class="qs_filter-field"
               [disabled]="this.isEditing"
               (keyup)="applyFilter($event.target.value)" placeholder="<Filter>">
        <button mat-button matSuffix mat-icon-button
                matTooltip="Clear the filter" aria-label="Clear"
                (click)="txtFilter.value=''; clearFilter();">
            <mat-icon>close</mat-icon>
        </button>
        -->
   </div>
</div>
<div class="dwform" style="padding-right: 0px;;height: 100%;" >

      <div class="dwform-cell-nopadding"
           style="min-width: 800px;width: 60%;padding-left: 3px;
           padding-right: 3px;">

      <!--LHS Fields -->
            <div [ngClass]="contentClassName" #tb1
                 class="table-container mat-elevation-z2"
                 style="height: 93%; border: .5px solid lightgray;outline:none;"
                 (keydown)="tableKeyDown($event)" tabindex="-1">

                    <table mat-table [dataSource]="dataSource" style="width: 100%" matSort
                        (matSortChange)="onSortChange($event)">

                      <ng-container matColumnDef="id">
                        <th mat-header-cell mat-sort-header class="mat-table-header-style mat-table-header-override"
                            *matHeaderCellDef> Id
                        </th>
                        <td mat-cell *matCellDef="let element" style="padding-left: 5px;"
                            class="table-row-class">
                        <span *ngIf="!isEditing">{{element.id}}</span>
                        </td>
                      </ng-container>
                        <ng-container matColumnDef="serviceRequestDesc">
                            <th mat-header-cell mat-sort-header class="mat-table-header-style mat-table-header-override"
                                *matHeaderCellDef>Request Type
                            </th>
                            <td mat-cell *matCellDef="let element" style="padding-left: 5px;"
                                class="table-row-class">
                                <span *ngIf="!isEditing">{{element.serviceRequestDesc}}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="serviceRange">
                          <th mat-header-cell mat-sort-header *matHeaderCellDef  class="mat-table-header-style mat-table-header-override"> Service Range </th>
                          <td mat-cell *matCellDef="let element"  style="padding-left: 1px" class="table-row-class">
                            <span *ngIf="!isEditing">{{element.startDate }} - {{element.endDate }}</span>
                          </td>
                        </ng-container>

                    <ng-container matColumnDef="amountRequested">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef
                          class="mat-table-header-style mat-table-header-override"> Requested </th>
                      <td mat-cell *matCellDef="let element" style="padding-left: 1px" class="table-row-class">
                        <span>{{amountLabel(element.id, true)}}</span>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="totalAmountProvided">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef
                            class="mat-table-header-style mat-table-header-override"> Provided </th>
                        <td mat-cell *matCellDef="let element" style="padding-left: 1px" class="table-row-class">
                            <span>{{amountLabel(element.id, false)}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="primaryAgency">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef class="mat-table-header-style mat-table-header-override"> Primary Agency </th>
                      <td mat-cell *matCellDef="let element" style="padding-left: 1px" class="table-row-class">
                      <span>{{element.primaryAgency}}</span>
                      </td>
                    </ng-container>
                   <ng-container matColumnDef="dateCompleted">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef
                          matTooltip="Date That The Request Was Finalized"
                          class="mat-table-header-style mat-table-header-override"> Date Completed </th>
                      <td mat-cell *matCellDef="let element" style="padding-left: 1px" class="table-row-class">
                      <span>{{element.dateCompleted | date:'mediumDate':'EST'}}</span>
                      </td>
                    </ng-container>
                      <ng-container matColumnDef="requestStatusDesc">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef
                            class="mat-table-header-style mat-table-header-override"> Status </th>
                        <td mat-cell *matCellDef="let element" style="padding-left: 1px" class="table-row-class">
                            <span *ngIf="!isEditing">{{element.requestStatusDesc}}</span>
                        </td>
                    </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                  <tr mat-row
                        *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                        [ngClass]="{'row-selected': tableRowIdx == Idx}"
                        (click)="onRowClicked(row)">
                      </tr>
                    </table>
                <app-dw-spinner [visible]="busyCursor"></app-dw-spinner>
          </div>
      </div>
 </div>

<p-dialog header="Add New Request" [focusOnShow]="false"
          [(visible)]="addNewRequestDlg" [modal]="true"
          [style]="{width: '570px', height: '475px'}"
          appendTo="body" [minY]="35" [resizable]="false" [closable]="false">
    <app-add-new-request-compact #newRequest
                                 (submitClickedEvent)="doSubmitNewRequestEvent($event)"
                                 (cancelClickedEvent)="addNewRequestDlg = false">
    </app-add-new-request-compact>
</p-dialog>

